<template>
  <div class="text-center text-grey-300">
    <IconMagnifyingGlass class="mx-auto mb-3 size-6 sm:mb-5 sm:size-10" />
    <p>
      {{ $t('no_entries_found') }}
    </p>
  </div>
</template>
